if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"transportation","remotes":[{"alias":"remote","name":"remote","entry":"https://dffoxz5he03rp.cloudfront.net/remote-build/production/_next/static/chunks/remote.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(1965|2840|3564|71|8884)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}